import { render, staticRenderFns } from "./SortField.vue?vue&type=template&id=45ce9234&scoped=true"
import script from "./SortField.ts?vue&type=script&lang=ts&external"
export * from "./SortField.ts?vue&type=script&lang=ts&external"
import style0 from "./SortField.scss?vue&type=style&index=0&id=45ce9234&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ce9234",
  null
  
)

export default component.exports